import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3c9c7175"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "pa-2",
  style: {"width":"50%"}
}
const _hoisted_2 = { class: "pa-4" }
const _hoisted_3 = { class: "ml-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, "Maint Plan ID"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, "Maint Plan Desc"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, "Asset"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, "Stat Flag"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, "Num Done (last 12 months)")
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))

import type { AssetManagementPlan } from "@/classes/asset-management-plan";
import { ref, watch } from "vue";
import RichText from "@/components/base/inputs/RichText.vue";
import { PreventativeMaintenanceData } from "@/store/asset-management-plan";
import axiosInstance from "@/plugins/axios";


export default /*#__PURE__*/_defineComponent({
  __name: 'DiffAssetManagementPlan',
  props: {
    plan: {},
    diffPlan: {},
    diff: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const tab = ref(0);

const preventativeMaintenance = ref<PreventativeMaintenanceData>({
  tactics: [],
  num_assets_applied: 0,
  num_assets: 0,
  num_workorders: 0,
  num_tactic_ops: 0,
});

const $axios = axiosInstance;

const loadingPreventative = ref(false);
const loadPreventativeMaintenance = async () => {
  loadingPreventative.value = true;
  preventativeMaintenance.value =
    await $axios.$post<PreventativeMaintenanceData>(
      "/asset-management-plan/preventative-maintenance-data",
      {
        floc_ids:
          props.plan?.floc_boundaries.map((b) => b.functional_location_id) ??
          [],
      },
    );
  loadingPreventative.value = false;
};

watch(
  () => props.plan?.id,
  async () => {
    await loadPreventativeMaintenance();
  },
  { immediate: true },
);

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_toolbar, {
      density: "compact",
      color: "grey-lighten-3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_tabs, {
          modelValue: tab.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plan?.individual_asset_management_plans ?? [], (_, i) => {
              return (_openBlock(), _createBlock(_component_v_tab, { key: i }, {
                default: _withCtx(() => [
                  _createTextVNode(" Plan " + _toDisplayString(i + 1), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_divider),
    _createVNode(_component_v_tabs_window, { "model-value": tab.value }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plan?.individual_asset_management_plans ??
        [], (individualPlan, i) => {
          return (_openBlock(), _createBlock(_component_v_tabs_window_item, {
            value: i,
            key: i
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar, {
                density: "compact",
                color: "grey-lighten-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_toolbar_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Plan " + _toDisplayString(i + 1), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createTextVNode(),
                  _createVNode(_component_v_spacer)
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(RichText, {
                  class: "mb-4",
                  "model-value": individualPlan.management_consideration_factors,
                  "diff-value": 
              _ctx.diffPlan?.individual_asset_management_plans[i]
                ?.management_consideration_factors
            ,
                  label: `5.${i + 1}.1 Management Consideration Factors`,
                  readonly: "",
                  options: { diff: _ctx.diff }
                }, null, 8, ["model-value", "diff-value", "label", "options"]),
                _createVNode(RichText, {
                  class: "mb-4",
                  "model-value": individualPlan.condition_monitoring,
                  "diff-value": 
              _ctx.diffPlan?.individual_asset_management_plans[i]
                ?.condition_monitoring
            ,
                  label: `5.${i + 1}.2 Condition Monitoring`,
                  readonly: "",
                  options: { diff: _ctx.diff }
                }, null, 8, ["model-value", "diff-value", "label", "options"]),
                _createVNode(RichText, {
                  class: "mb-4",
                  "model-value": individualPlan.maintenance_defect_management,
                  "diff-value": 
              _ctx.diffPlan?.individual_asset_management_plans[i]
                ?.maintenance_defect_management
            ,
                  label: `5.${i + 1}.3 Maintenance & Defect Management`,
                  readonly: "",
                  options: { diff: _ctx.diff }
                }, null, 8, ["model-value", "diff-value", "label", "options"]),
                _createVNode(RichText, {
                  class: "mb-4",
                  "model-value": individualPlan.maintenance_plans,
                  "diff-value": 
              _ctx.diffPlan?.individual_asset_management_plans[i]?.maintenance_plans
            ,
                  label: `5.${i + 1}.4 Maintenance Plans`,
                  readonly: "",
                  options: { diff: _ctx.diff }
                }, null, 8, ["model-value", "diff-value", "label", "options"]),
                _createVNode(_component_v_card, {
                  class: "mb-4",
                  variant: "outlined",
                  rounded: "lg"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_toolbar, { density: "compact" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_toolbar_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(" 5." + _toDisplayString(i + 1) + ".5 Preventative Maintenance Tactics ", 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_spacer),
                        _createElementVNode("span", null, " # Assets Applied: " + _toDisplayString(preventativeMaintenance.value.num_assets_applied) + " / " + _toDisplayString(preventativeMaintenance.value.num_assets) + ", ", 1),
                        _createElementVNode("span", _hoisted_3, " # Compliance: " + _toDisplayString(preventativeMaintenance.value.num_workorders) + " / " + _toDisplayString(preventativeMaintenance.value.num_tactic_ops), 1),
                        _createVNode(_component_v_tooltip, {
                          text: "Refresh",
                          location: "bottom"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn, _mergeProps({ ref_for: true }, props, {
                              class: "ml-3",
                              icon: "mdi-reload",
                              density: "compact",
                              loading: loadingPreventative.value,
                              onClick: loadPreventativeMaintenance
                            }), null, 16, ["loading"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_table, {
                      class: "tactics-table",
                      "fixed-header": "",
                      density: "compact"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_4,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preventativeMaintenance.value.tactics, (tactic, i) => {
                            return (_openBlock(), _createElementBlock("tr", { key: i }, [
                              _createElementVNode("td", null, _toDisplayString(tactic.maint_plan_id), 1),
                              _createElementVNode("td", null, _toDisplayString(tactic.maint_plan_description), 1),
                              _createElementVNode("td", null, _toDisplayString(tactic.asset_name), 1),
                              _hoisted_5,
                              _createElementVNode("td", null, _toDisplayString(tactic.num_workorders) + " / " + _toDisplayString(tactic.num_tactic_ops), 1)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(RichText, {
                  class: "mb-4",
                  "model-value": individualPlan.statutary_requirements,
                  "diff-value": 
              _ctx.diffPlan?.individual_asset_management_plans[i]
                ?.statutary_requirements
            ,
                  label: `5.${i + 1}.6 Statutary Requirements`,
                  readonly: "",
                  options: { diff: _ctx.diff }
                }, null, 8, ["model-value", "diff-value", "label", "options"]),
                _createVNode(RichText, {
                  class: "mb-4",
                  "model-value": individualPlan.equipment_decomissioning_disposal,
                  "diff-value": 
              _ctx.diffPlan?.individual_asset_management_plans[i]
                ?.equipment_decomissioning_disposal
            ,
                  label: `5.${i + 1}.7 Equipment Decomissioning & Disposal`,
                  readonly: "",
                  options: { diff: _ctx.diff }
                }, null, 8, ["model-value", "diff-value", "label", "options"]),
                _createVNode(RichText, {
                  class: "mb-4",
                  "model-value": individualPlan.capital_projects,
                  "diff-value": 
              _ctx.diffPlan?.individual_asset_management_plans[i]?.capital_projects
            ,
                  label: `5.${i + 1}.8 Capital Projects`,
                  readonly: "",
                  options: { diff: _ctx.diff }
                }, null, 8, ["model-value", "diff-value", "label", "options"])
              ])
            ]),
            _: 2
          }, 1032, ["value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["model-value"])
  ]))
}
}

})